import type { ConstraintInputType, ConstraintFieldType } from '../../../../config/optimizePlanConfig';

// Derived from ConstraintLevelOption['key'] — stays in sync with the config.
export type Level = string;

export interface FormData {
    objective: string | null;
    optimization_start_date: number | null;
    keep_top: number | null;
    concurrent_tprs: number | null;
    concurrent_fds: number | null;
    concurrent_mdfs: number | null;
    [key: string]: string | number | null;
}

export interface ConstraintRowData {
    name: string;
    label: string;
    fields: Record<string, unknown>; // Dynamic column values keyed by config column.key (which matches the API field name).
    min_value: number | null;
    max_value: number | null;
    single_value?: number | null;
    constraint_type?: ConstraintInputType;
    fieldType?: ConstraintFieldType;
    levelDetails?: ConstraintRowData[];
}

export const INITIAL_FORM_DATA: FormData = {
    optimization_start_date: null,
    objective: null,
    keep_top: null,
    concurrent_tprs: null,
    concurrent_fds: null,
    concurrent_mdfs: null,
};
